import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import NotificationSystem from "react-notification-system";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  Panel,
  Form,
  Modal
} from "react-bootstrap";

import * as actions from "../../actions/streamConfigActions";
import { Card } from "../../components/Card/Card.jsx";
import HorizontalFormInputs from "../../components/FormInputs/HorizontalFormInputs.jsx";
import HorizontalFormInputsWithTooltip from "../../components/FormInputs/HorizontalFormInputsWithTooltip.jsx";
import { Dropdown } from "../../components/Dropdown/Dropdown.jsx";
import Checkbox from "../../components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "../../components/CustomButton/CustomButton.jsx";
import "../../assets/css/settings-page.css";
import style from "../../variables/Variables";
import { KeyValueDropdown } from "../../components/Dropdown/KeyValueDropdown";

class StreamConfig extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      container: Object.assign({}, props.container),
      sourceSrtMode: Object.assign({ disabled: true }, props.sourceSrtMode),
      destSrtMode: Object.assign({ disabled: true }, props.destSrtMode),
      destDashMode: Object.assign({ disabled: true }, props.destDashMode),
      destHlsMode: Object.assign({ disabled: true }, props.destHlsMode),
      destQamMode: Object.assign({ disabled: true }, props.destQamMode),
      sourceOutgoingPort: Object.assign({ disabled: true }, props.sourceOutgoingPort),
      destOutgoingPort: Object.assign({ disabled: true }, props.destOutgoingPort),
      _notificationSystem: null,
      sourceIPError: false,
      sourcePortError: false,
      sourceSSMIPError: false,
      sourceOutgoingPortError: false,
      destIPError: false,
      destPortError: false,
      destOutgoingPortError: false,
      destDashSegmentDurationError: false,
      destDashMinUpdatePeriodError: false,
      destDashMinBufferTimeError: false,
      destDashSuggestedPresentationDelayError: false,
      destDashTimeShiftBufferDepthError: false,
      destDashPreservedSegmentsOutsideOfLiveWindowError: false,
      destHlsSegmentDurationError: false,
      destHlsFragmentDurationError: false,
      destHlsTimeShiftBufferDepthError: false,
      destHlsPreservedSegmentsOutsideOfLiveWindowError: false,
      destQamFrequencyError: false,
      destQamModeError: false,
      destQamInterleaverError: false,
      intervalError: false,
      formValid: false,
      sourceAdapterErrorValidate: false,
      sourceIPErrorValidate: false,
      sourcePortErrorValidate: false,
      destProtocolErrorValidate: false,
      destAdapterErrorValidate: false,
      destIPErrorValidate: false,
      destPortErrorValidate: false,
      enableDASH: props.enableDASH,
      enableQam: props.enableQam
    };
    this.onSave = this.onSave.bind(this);

    this.updateState = this.updateState.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      sourceAdapterErrorValidate: false,
      sourceIPErrorValidate: false,
      sourcePortErrorValidate: false,
      destProtocolErrorValidate: false,
      destAdapterErrorValidate: false,
      destIPErrorValidate: false,
      destPortErrorValidate: false
    });
    if (nextProps.validationError && nextProps.validationError.fields) {
      nextProps.validationError.fields.forEach((field) => {
        this.setState({
          [field + 'ErrorValidate']: (
                <small className="text-danger" style={{ marginLeft: 200 + "px" }}>
                {nextProps.validationError.message}
              </small>
            )
          })
      });
    }
  }

  updateState = (value, label) => {
    const container = this.state.container;
    container[label] = value;
    if (label === "sourceProtocol") {
      if (value.toLowerCase() === "udp") {
        container["sourceSrtMode"] = "";
        return this.setState({
          sourceSrtMode: { disabled: true },
          sourceOutgoingPort: { disabled: true },
          container: container
        });
      }
      if (value.toLowerCase() === "srt") {
        this.setState({ sourceSrtMode: { disabled: false }, sourceOutgoingPort: this.updateStateSourceOutgoingPort() });
      }
    }
    if (label === "destProtocol") {
      if (value.toLowerCase() === "udp") {
        container["destSrtMode"] = "";
        container["destQamMode"] = "";
        return this.setState({
          destSrtMode: { disabled: true },
          destOutgoingPort: { disabled: true },
          destDashMode: { disabled: true },
          destHlsMode: { disabled: true },
          destQamMode: { disabled: true },
          container: container
        });
      }
      
      if (value.toLowerCase() === "srt") {
        container["destQamMode"] = "";
        this.setState({ 
          destSrtMode: { disabled: false },
          destOutgoingPort: this.updateStateDestOutgoingPort(),
          destDashMode: { disabled: true },
          destHlsMode: { disabled: true },
          destQamMode: { disabled: true },
        });
      }

      if (value.toLowerCase() === "dash") {
        container["destSrtMode"] = "";
        container["destQamMode"] = "";
        this.setState({ 
          destSrtMode: { disabled: true },
          destOutgoingPort: { disabled: true },
          destDashMode: { disabled: false },
          destHlsMode: { disabled: true },
          destQamMode: { disabled: true },
          container: container
        });
      }

      if (value.toLowerCase() === "hls") {
        container["destSrtMode"] = "";
        container["destQamMode"] = "";
        this.setState({ 
          destSrtMode: { disabled: true },
          destOutgoingPort: { disabled: true },
          destDashMode: { disabled: true },
          destHlsMode: { disabled: false },
          destQamMode: { disabled: true },
          container: container
        });
      }

      if (value.toLowerCase() === "qam") {
        container["destSrtMode"] = "";
        this.setState({
          destSrtMode: { disabled: true },
          destOutgoingPort: { disabled: true },
          destDashMode: { disabled: true },
          destHlsMode: { disabled: true },
          destQamMode: { disabled: false },
          container: container
        });
      }
    }

    if (label === 'destQamFrequency' || label === 'destQamMode' || label === 'destQamInterleaver'){
      let qamConfig = Object.assign({
        frequency: "",
        mode: "",
        interleaver: ""
      }, container.qamConfig)
      if (label === 'destQamFrequency') {
        qamConfig['frequency'] = value;
      }
      if (label === 'destQamMode') {
        qamConfig['mode'] = value;
      }
      if (label === 'destQamInterleaver') {
        qamConfig['interleaver'] = value;
      }
      container["qamConfig"] = qamConfig;
    }

    if (label === "sourceSrtMode") {
      if (value.toLowerCase() !== "caller") {
        container["sourceOutgoingPort"] = "";
        return this.setState({
          sourceOutgoingPort: { disabled: true },
          container: container
        });
      } else {
        this.setState({ sourceOutgoingPort: { disabled: false } });
      }
    }

    if (label === "destSrtMode") {
      if (value.toLowerCase() !== "caller") {
        container["destOutgoingPort"] = "";
        return this.setState({
          destOutgoingPort: { disabled: true },
          container: container
        });
      } else {
        this.setState({ destOutgoingPort: { disabled: false } });
      }
    }

    if (label === 'sourceAdapter' || label === 'destAdapter'){
      let n1 = this.props.nics.filter( nic => {
        if(nic[value]) return nic[value];
      })
      container[label] = n1[0][Object.keys(n1[0])[0]].address;
      container[label + "Name"] = value;
    }

    this.setState({ container: container }, this.validateForm);
  };

  updateStateSourceOutgoingPort = () => {
    if (!this.state.container.sourceSrtMode || this.state.container.sourceSrtMode.toLowerCase() !== "caller")
      return { disabled: true };
    else
      return { disabled: false };
  };

  updateStateDestOutgoingPort = () => {
    if (!this.state.container.destSrtMode || this.state.container.destSrtMode.toLowerCase() !== "caller")
      return { disabled: true };
    else
      return { disabled: false };
  };

  handleIPUpdate = (value, label) => {
    this.updateState(value, label);
    if (value) {
     // validate sourceIP
     var re = /^((?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))(?![\d])$/;
     re.test(value) === false
       ? this.setState({
        [label + 'Error']: (
              <small className="text-danger" style={{ marginLeft: 200 + "px" }}>
              Please enter valid IP Address such as: <i>127.0.0.1</i>.
            </small>
          )
         })
       : this.setState({ [label + 'Error']: false });
    } else {
      this.setState({ [label + 'Error']: false });
    }
  };

  handleSourcePortUpdate = (value, label) => {
  this.updateState(value, label);
       // validate sourcePort
       var re = /^([1-9]|[1-8][0-9]|9[0-9]|[1-8][0-9]{2}|9[0-8][0-9]|99[0-9]|[1-8][0-9]{3}|9[0-8][0-9]{2}|99[0-8][0-9]|999[0-9]|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/;
       re.test(value) === false
         ? this.setState({
           sourcePortError: (
            <small className="text-danger" style={{ marginLeft: 200 + "px" }}>
                 Please enter port in range <i>1-65535</i>.
               </small>
             )
           })
         : this.setState({ sourcePortError: false });
  };

  handleDestPortUpdate = (value, label) => {
  this.updateState(value, label);
       // validate sourcePort
       var re = /^([1-9]|[1-8][0-9]|9[0-9]|[1-8][0-9]{2}|9[0-8][0-9]|99[0-9]|[1-8][0-9]{3}|9[0-8][0-9]{2}|99[0-8][0-9]|999[0-9]|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/;
       re.test(value) === false
         ? this.setState({
           destPortError: (
            <small className="text-danger" style={{ marginLeft: 200 + "px" }}>
                 Please enter port in range <i>1-65535</i>.
               </small>
             )
           })
         : this.setState({ destPortError: false });
  };

  handleSourceOutgoingPortUpdate = (value, label) => {
  this.updateState(value, label);
        // validate sourcePort
        var re = /^([1-9]|[1-8][0-9]|9[0-9]|[1-8][0-9]{2}|9[0-8][0-9]|99[0-9]|[1-8][0-9]{3}|9[0-8][0-9]{2}|99[0-8][0-9]|999[0-9]|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/;
        re.test(value) === false
          ? this.setState({
            sourceOutgoingPortError: (
            <small className="text-danger" style={{ marginLeft: 200 + "px" }}>
                  Please enter outgoing port in range <i>1-65535</i>.
                </small>
              )
            })
          : this.setState({ sourceOutgoingPortError: false });
  };

  handleDestOutgoingPortUpdate = (value, label) => {
  this.updateState(value, label);
        // validate sourcePort
        var re = /^([1-9]|[1-8][0-9]|9[0-9]|[1-8][0-9]{2}|9[0-8][0-9]|99[0-9]|[1-8][0-9]{3}|9[0-8][0-9]{2}|99[0-8][0-9]|999[0-9]|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/;
        re.test(value) === false
          ? this.setState({
            destOutgoingPortError: (
            <small className="text-danger" style={{ marginLeft: 200 + "px" }}>
                  Please enter outgoing port in range <i>1-65535</i>.
                </small>
              )
            })
          : this.setState({ destOutgoingPortError: false });
  };

  handleNumericFieldUpdate = (value, label) =>{
  this.updateState(value, label);
  var re = /^[0-9]+(.[0-9]+)?$/;
  if(label === 'destDashPreservedSegmentsOutsideOfLiveWindow' || label === 'destHlsPreservedSegmentsOutsideOfLiveWindow') {
    re = /^[0-9]+?$/;
  }
  value != '' && re.test(value) === false
    ? this.setState({
      [label + 'Error']: (
          <small className="text-danger" style={{marginLeft: 200 + "px"}}>
            Please enter numeric value.
          </small>
        )
      })
    : this.setState({ [label + 'Error']: false });
  };

  handleFrequency = (value, label) => {
    this.updateState(value, label);
          // validate Frequency
          (value < 36000 || value > 999000)
            ? this.setState({
              destQamFrequencyError: (
              <small className="text-danger" style={{ marginLeft: 200 + "px" }}>
                    Please enter frequency in range <i>36000-999000</i>.
                  </small>
                )
              })
            : this.setState({ destQamFrequencyError: false });
  };

  handleInterval = (value, label) => {
    this.updateState(value, label);
          // validate Frequency
          (value < 30)
            ? this.setState({
              intervalError: (
              <small className="text-danger" style={{ marginLeft: 200 + "px" }}>
                    Please enter interval more than <i>29</i>.
                  </small>
                )
              })
            : this.setState({ intervalError: false });
  };

  onSave = event => {
    event.preventDefault();
    this.props.actions
      .saveNewStream(this.state.container, window.location.origin)
      .then(() => {
        console.log("Save new Stream!");
        const container = this.state.container;
        container.Id = 0;
        container.destDashDir = "";
        this.setState({ container: container });
    })
    .catch(err => {
      console.log(`error saving new stream!${err}`);
      });
  };

  validateForm() {
    this.setState({
      formValid:
        this.state.sourcePortError === false &&
        this.state.destPortError === false &&
        this.state.sourceIPError === false &&
        this.state.sourceSSMIPError === false &&
        this.state.destIPError === false &&
        this.state.destDashSegmentDurationError === false &&
        this.state.destDashMinUpdatePeriodError === false &&
        this.state.destDashMinBufferTimeError === false &&
        this.state.destDashSuggestedPresentationDelayError === false &&
        this.state.destDashTimeShiftBufferDepthError === false &&
        this.state.destDashPreservedSegmentsOutsideOfLiveWindowError === false &&
        this.state.destHlsSegmentDurationError === false &&
        this.state.destHlsFragmentDurationError === false &&
        this.state.destHlsTimeShiftBufferDepthError === false &&
        this.state.destHlsPreservedSegmentsOutsideOfLiveWindowError === false &&
        this.state.destQamFrequencyError === false && 
        this.state.intervalError === false
	});
  }

  render() {
    // const portToolTip = <Tooltip>Suggested port range to use in this field is 49152-65535</Tooltip>;
    let destProtocolOptions = this.state.enableDASH ? ["SRT", "UDP", "DASH", "HLS"] : ["SRT", "UDP"];
    if(this.state.enableQam) {
      destProtocolOptions.push("QAM");
    }
    return (
      <div className="content">
      <NotificationSystem ref="notificationSystem" style={style} />
        <Grid fluid>
          <Form horizontal>
            <Panel bsStyle="primary">
              <Panel.Heading>
                <Panel.Title componentClass="h3">
                  Stream Configuration
                </Panel.Title>
              </Panel.Heading>
              <Panel.Body>
                <Row>
                  <Col md={6}>
                    <Card
                      title="Input Stream"
                      content={
                        <div className={"form form-horizontal"}>
                          <Dropdown
                            ncols={["col-md-12"]}
                            onValueChange={this.updateState}
                            statekey="sourceProtocol"
                            title={this.state.container.sourceProtocol}
                            proprieties={[
                              {
                                label: "Protocol",
                                type: "text",
                                bsClass: "form-control",
                                placeholder: "Select Protocol",
                                children: ["SRT", "UDP"]
                              }
                            ]}
                          />
                          <Dropdown
                            ncols={["col-md-12"]}
                            onValueChange={this.updateState}
                            statekey="sourceSrtMode"
                            title={this.state.container.sourceSrtMode}
                            disabled={this.state.sourceSrtMode.disabled}
                            hidden={this.state.sourceSrtMode.disabled}
                            proprieties={[
                              {
                                label: "SRT Mode",
                                type: "text",
                                bsClass: "form-control",
                                placeholder: "Select SRT Mode",
                                children: ["Listener", "Caller", "Rendezvous"]
                              }
                            ]}
                          />
                          <KeyValueDropdown
                            ncols={["col-md-12"]}
                            onValueChange={this.updateState}
                            statekey="sourceAdapter"
                            hidden={this.state.container.sourceProtocol == ""}
                            proprieties={[
                              {
                                label: "Interface",
                                type: "text",
                                bsClass: "form-control",
                                placeholder: "Select Interface",
                                defaultValue: this.props.sourceAdapter,
                                children: this.props.nics
                              }
                            ]}
                          />
                          {this.state.sourceAdapterErrorValidate}

                          <HorizontalFormInputs
                            ncols={["col-md-12"]}
                            label="IP Address"
                            onValueChange={this.handleIPUpdate}
                            statekey="sourceIP"
                            value={this.state.container.sourceIP}
                            type="text"
                            bsClass="form-control"
                            placeholder="Enter IP"
                            hidden={this.state.container.sourceProtocol == ""}
                          />
                          {this.state.sourceIPError}
                          {this.state.sourceIPErrorValidate}

                          <HorizontalFormInputsWithTooltip
                            ncols={["col-md-12"]}
                            label="Port"
                            onValueChange={this.handleSourcePortUpdate}
                            statekey="sourcePort"
                            value={this.state.container.sourcePort}
                            type="text"
                            bsClass="form-control"
                            placeholder="Enter Port"
                            tooltip="Suggested port range to use in this field is 49152-65535"
                            hidden={this.state.container.sourceProtocol == ""}
                          />
                          {this.state.sourcePortError}
                          {this.state.sourcePortErrorValidate}

                          <HorizontalFormInputs
                            ncols={["col-md-12"]}
                            label="SSM IP Address"
                            onValueChange={this.handleIPUpdate}
                            statekey="sourceSSMIP"
                            value={this.state.container.sourceSSMIP}
                            type="text"
                            bsClass="form-control"
                            placeholder="Enter SSM IP"
                            hidden={this.state.container.sourceProtocol.toLowerCase() !== "udp"}
                          />
                          {this.state.sourceSSMIPError}
                          <HorizontalFormInputsWithTooltip
                            ncols={["col-md-12"]}
                            label="Outgoing Port"
                            onValueChange={this.handleSourceOutgoingPortUpdate}
                            statekey="sourceOutgoingPort"
                            value={this.state.container.sourceOutgoingPort}
                            disabled={this.state.sourceOutgoingPort.disabled}
                            hidden={this.state.sourceOutgoingPort.disabled}
                            type="text"
                            bsClass="form-control"
                            placeholder="Enter Outgoing Port"
                            tooltip="Suggested outgoing port range to use in this field is 49152-65535"
                          />
                          {this.state.sourceOutgoingPortError}
                          <HorizontalFormInputs
                            ncols={["col-md-12"]}
                            label="Latency"
                            onValueChange={this.updateState}
                            statekey="sourceLatency"
                            value={this.state.container.sourceLatency}
                            type="text"
                            bsClass="form-control"
                            placeholder="150ms"
                            disabled={this.state.sourceSrtMode.disabled}
                            hidden={this.state.sourceSrtMode.disabled}
                          />
                          <HorizontalFormInputs
                            ncols={["col-md-12"]}
                            label="TTL"
                            onValueChange={this.updateState}
                            statekey="sourceTtl"
                            value={this.state.container.sourceTtl}
                            type="text"
                            bsClass="form-control"
                            placeholder="32"
                            hidden={this.state.container.sourceProtocol == ""}
                            // disabled={this.state.sourceSrtMode.disabled}
                          />
                          <FormGroup style={{ marginBottom: -10 + "px" }}>
                            <Col
                              componentClass={ControlLabel}
                              style={{ marginTop: 5 + "px" }}
                              md={5}
                            >
                              <Checkbox
                                number="cb1"
                                checked={this.state.container.sourceDropPackets}
                                statekey="sourceDropPackets"
                                onValueChange={this.updateState}
                                label="Drop packets"
                                inline={true}
                                disabled={this.state.sourceSrtMode.disabled}
                                hidden={this.state.sourceSrtMode.disabled}
                              />
                            </Col>
                          </FormGroup>

                          <HorizontalFormInputs
                            ncols={["col-md-12"]}
                            label="Timeout"
                            onValueChange={this.updateState}
                            statekey="sourceTimeout"
                            value={this.state.container.sourceTimeout}
                            type="text"
                            bsClass="form-control"
                            placeholder="Enter timeout"
                            disabled={this.state.sourceSrtMode.disabled}
                            hidden={this.state.sourceSrtMode.disabled}
                          />
                          <Dropdown
                            ncols={["col-md-12"]}
                            onValueChange={this.updateState}
                            statekey="sourceEncryption"
                            title={this.props.sourceEncryption}
                            disabled={this.state.sourceSrtMode.disabled}
                            hidden={this.state.sourceSrtMode.disabled}
                            proprieties={[
                              {
                                label: "Encryption",
                                type: "text",
                                bsClass: "form-control",
                                placeholder: "Select Encryption",
                                defaultValue: "Disabled",
                                children: [
                                  "Disabled",
                                  "AES128",
                                  "AES196",
                                  "AES256"
                                ]
                              }
                            ]}
                          />
                          <HorizontalFormInputs
                            ncols={["col-md-12"]}
                            label="Encryption key"
                            onValueChange={this.updateState}
                            statekey="sourceEncryptionKey"
                            value={this.state.container.sourceEncryptionKey}
                            type="text"
                            bsClass="form-control"
                            placeholder="Key"
                            disabled={this.state.sourceSrtMode.disabled}
                            hidden={this.state.sourceSrtMode.disabled}
                          />
                          <div className="clearfix" />
                        </div>
                      }
                    />
                  </Col>
                  {/* <Col md={1}>
                  <div className=" all-icons" style={{ textAlign: "center" }}>
                    <i className="pe-7s-angle-right-circle" />
                  </div>
                </Col> */}
                  <Col md={6}>
                    <Card
                      title="Output Stream"
                      content={
                        <div className={"form form-horizontal"}>
                          <Dropdown
                            ncols={["col-md-12"]}
                            onValueChange={this.updateState}
                            statekey="destProtocol"
                            title={this.state.container.destProtocol}
                            proprieties={[
                              {
                                label: "Protocol",
                                type: "text",
                                bsClass: "form-control",
                                placeholder: "Select Protocol",
                                children: destProtocolOptions
                              }
                            ]}
                          />
                          {this.state.destProtocolErrorValidate}
                          <Dropdown
                            ncols={["col-md-12"]}
                            onValueChange={this.updateState}
                            statekey="destSrtMode"
                            disabled={this.state.destSrtMode.disabled}
                            hidden={this.state.destSrtMode.disabled}
                            title={this.state.container.destSrtMode}
                            proprieties={[
                              {
                                label: "SRT Mode",
                                type: "text",
                                bsClass: "form-control",
                                placeholder: "Select SRT Mode",
                                children: ["Listener", "Caller", "Rendezvous"]
                              }
                            ]}
                          />

                          <KeyValueDropdown
                            ncols={["col-md-12"]}
                            onValueChange={this.updateState}
                            statekey="destAdapter"
                            hidden={this.state.container.destProtocol == "" || !this.state.destQamMode.disabled}
                            proprieties={[
                              {
                                label: "Interface",
                                type: "button-group",
                                bsClass: "button-group",
                                placeholder: "Select Interface",
                                defaultValue: this.props.destAdapter,
                                children: this.props.nics
                              }
                            ]}
                          />
                          {this.state.destAdapterErrorValidate}

                          <HorizontalFormInputs
                            ncols={["col-md-12"]}
                            label="IP Address"
                            onValueChange={this.handleIPUpdate}
                            statekey="destIP"
                            value={this.state.container.destIP}
                            type="text"
                            bsClass="form-control"
                            placeholder="Enter IP"
                            hidden={this.state.container.destProtocol == "" || !this.state.destDashMode.disabled || !this.state.destHlsMode.disabled || !this.state.destQamMode.disabled}
                          />
                          {this.state.destIPError}
                          {this.state.destIPErrorValidate}
                          <HorizontalFormInputsWithTooltip
                            ncols={["col-md-12"]}
                            label="Port"
                            onValueChange={this.handleDestPortUpdate}
                            statekey="destPort"
                            value={this.state.container.destPort}
                            type="text"
                            bsClass="form-control"
                            placeholder="Port"
                            tooltip="Suggested port range to use in this field is 49152-65535"
                            hidden={this.state.container.destProtocol == "" || !this.state.destDashMode.disabled || !this.state.destHlsMode.disabled || !this.state.destQamMode.disabled}
                          />
                          {this.state.destPortError}
                          {this.state.destPortErrorValidate}
                          <HorizontalFormInputsWithTooltip
                            ncols={["col-md-12"]}
                            label="Outgoing Port"
                            onValueChange={this.handleDestOutgoingPortUpdate}
                            statekey="destOutgoingPort"
                            value={this.state.container.destOutgoingPort}
                            disabled={this.state.destOutgoingPort.disabled}
                            hidden={this.state.destOutgoingPort.disabled}
                            type="text"
                            bsClass="form-control"
                            placeholder="Outgoing Port"
                            tooltip="Suggested outgoing port range to use in this field is 49152-65535"
                          />
                          {this.state.destOutgoingPortError}
                          <HorizontalFormInputs
                            ncols={["col-md-12"]}
                            label="Latency"
                            onValueChange={this.updateState}
                            statekey="destLatency"
                            value={this.state.container.destLatency}
                            type="text"
                            bsClass="form-control"
                            placeholder="150ms"
                            disabled={this.state.destSrtMode.disabled}
                            hidden={this.state.destSrtMode.disabled}
                          />
                          <HorizontalFormInputs
                            ncols={["col-md-12"]}
                            label="TTL"
                            onValueChange={this.updateState}
                            statekey="destTtl"
                            value={this.state.container.destTtl}
                            type="text"
                            bsClass="form-control"
                            placeholder="32"
                            hidden={this.state.container.destProtocol == "" || !this.state.destQamMode.disabled}
                            // disabled={this.state.destSrtMode.disabled}
                          />
                          
                          <HorizontalFormInputs
                            ncols={["col-md-12"]}
                            label="Frequency"
                            onValueChange={this.handleFrequency}
                            statekey="destQamFrequency"
                            value={this.state.container.qamConfig.frequency}
                            type="text"
                            bsClass="form-control"
                            placeholder="36000"
                            hidden={this.state.destQamMode.disabled}
                            disabled={this.state.destQamMode.disabled}
                          />
                          {this.state.destQamFrequencyError}
                          <Dropdown
                            ncols={["col-md-12"]}
                            onValueChange={this.updateState}
                            statekey="destQamMode"
                            title={this.state.container.qamConfig.mode}
                            disabled={this.state.destQamMode.disabled}
                            hidden={this.state.destQamMode.disabled}
                            proprieties={[
                              {
                                label: "QAM Mode",
                                type: "text",
                                bsClass: "form-control",
                                placeholder: "Select Mode",
                                children: [
                                  "QAM64",
                                  "QAM256"
                                ]
                              }
                            ]}
                          />
                          {this.state.destQamModeError}
                          <Dropdown
                            ncols={["col-md-12"]}
                            onValueChange={this.updateState}
                            statekey="destQamInterleaver"
                            title={this.state.container.qamConfig.interleaver}
                            disabled={this.state.destQamMode.disabled}
                            hidden={this.state.destQamMode.disabled}
                            proprieties={[
                              {
                                label: "Interleaver",
                                type: "text",
                                bsClass: "form-control",
                                placeholder: "Select Interleaver",
                                children: [
                                  "128, 1",
                                  "128, 2",
                                  "64, 2",
                                  "128, 3",
                                  "32, 4",
                                  "128, 4",
                                  "16, 8",
                                  "128, 5",
                                  "8, 16"
                                ]
                              }
                            ]}
                          />
                          {this.state.destQamInterleaverError}

                          <FormGroup style={{ marginBottom: -10 + "px" }}>
                            <Col
                              componentClass={ControlLabel}
                              style={{ marginTop: 5 + "px" }}
                              md={5}
                            >
                              <Checkbox
                                number="1"
                                checked={this.state.container.destDropPackets}
                                label="Drop packets"
                                statekey="destDropPackets"
                                onChange={this.updateState}
                                inline={true}
                                disabled={this.state.destSrtMode.disabled}
                                hidden={this.state.destSrtMode.disabled}
                              />
                            </Col>
                          </FormGroup>
                          <HorizontalFormInputs
                            ncols={["col-md-12"]}
                            label="Timeout"
                            onValueChange={this.updateState}
                            statekey="destTimeout"
                            type="text"
                            bsClass="form-control"
                            value={this.state.container.destTimeout}
                            placeholder="150ms"
                            disabled={this.state.destSrtMode.disabled}
                            hidden={this.state.destSrtMode.disabled}
                          />
                          <Dropdown
                            ncols={["col-md-12"]}
                            onValueChange={this.updateState}
                            statekey="destEncryption"
                            title={this.props.destEncryption}
                            disabled={this.state.destSrtMode.disabled}
                            hidden={this.state.destSrtMode.disabled}
                            proprieties={[
                              {
                                label: "Encryption",
                                type: "text",
                                bsClass: "form-control",
                                placeholder: "Select Encryption",
                                defaultValue: "Disabled",
                                children: [
                                  "Disabled",
                                  "AES128",
                                  "AES196",
                                  "AES256"
                                ]
                              }
                            ]}
                          />
                          <HorizontalFormInputs
                            ncols={["col-md-12"]}
                            label="Encryption key"
                            onValueChange={this.updateState}
                            statekey="destEncryptionKey"
                            value={this.state.container.destEncryptionKey}
                            type="text"
                            bsClass="form-control"
                            placeholder="Key"
                            disabled={this.state.destSrtMode.disabled}
                            hidden={this.state.destSrtMode.disabled}
                          />

                          <HorizontalFormInputs
                            ncols={["col-md-12"]}
                            label="Segment duration"
                            onValueChange={this.handleNumericFieldUpdate}
                            statekey="destDashSegmentDuration"
                            value={this.state.container.destDashSegmentDuration}
                            type="text"
                            bsClass="form-control"
                            placeholder="seconds"
                            disabled={this.state.destDashMode.disabled}
                            hidden={this.state.destDashMode.disabled}
                          />
                          {this.state.destDashSegmentDurationError}
                          <HorizontalFormInputs
                            ncols={["col-md-12"]}
                            label="Min update period"
                            onValueChange={this.handleNumericFieldUpdate}
                            statekey="destDashMinUpdatePeriod"
                            value={this.state.container.destDashMinUpdatePeriod}
                            type="text"
                            bsClass="form-control"
                            placeholder="seconds"
                            disabled={this.state.destDashMode.disabled}
                            hidden={this.state.destDashMode.disabled}
                          />
                          {this.state.destDashMinUpdatePeriodError}
                          <HorizontalFormInputs
                            ncols={["col-md-12"]}
                            label="Min buffer time"
                            onValueChange={this.handleNumericFieldUpdate}
                            statekey="destDashMinBufferTime"
                            value={this.state.container.destDashMinBufferTime}
                            type="text"
                            bsClass="form-control"
                            placeholder="seconds"
                            disabled={this.state.destDashMode.disabled}
                            hidden={this.state.destDashMode.disabled}
                          />
                          {this.state.destDashMinBufferTimeError}
                          <HorizontalFormInputs
                            ncols={["col-md-12"]}
                            label="Suggested presentation delay"
                            onValueChange={this.handleNumericFieldUpdate}
                            statekey="destDashSuggestedPresentationDelay"
                            value={this.state.container.destDashSuggestedPresentationDelay}
                            type="text"
                            bsClass="form-control"
                            placeholder="seconds"
                            disabled={this.state.destDashMode.disabled}
                            hidden={this.state.destDashMode.disabled}
                          />
                          {this.state.destDashSuggestedPresentationDelayError}
                          <HorizontalFormInputs
                            ncols={["col-md-12"]}
                            label="Time shift buffer depth"
                            onValueChange={this.handleNumericFieldUpdate}
                            statekey="destDashTimeShiftBufferDepth"
                            value={this.state.container.destDashTimeShiftBufferDepth}
                            type="text"
                            bsClass="form-control"
                            placeholder="seconds"
                            disabled={this.state.destDashMode.disabled}
                            hidden={this.state.destDashMode.disabled}
                          />
                          {this.state.destDashTimeShiftBufferDepthError}
                          <HorizontalFormInputs
                            ncols={["col-md-12"]}
                            label="Preserved segments outside of live window"
                            onValueChange={this.handleNumericFieldUpdate}
                            statekey="destDashPreservedSegmentsOutsideOfLiveWindow"
                            value={this.state.container.destDashPreservedSegmentsOutsideOfLiveWindow}
                            type="text"
                            bsClass="form-control"
                            placeholder="number of segments"
                            disabled={this.state.destDashMode.disabled}
                            hidden={this.state.destDashMode.disabled}
                          />
                          {this.state.destDashPreservedSegmentsOutsideOfLiveWindowError}
                          <FormGroup style={{ marginBottom: -10 + "px" }}>
                            <Col
                              componentClass={ControlLabel}
                              style={{ marginTop: 5 + "px" }}
                              md={5}
                            >
                              <Checkbox
                                number="cb3"
                                checked={this.state.container.destDashSegmentTemplateConstantDuration}
                                label="Segment Template with constant duration"
                                statekey="destDashSegmentTemplateConstantDuration"
                                onValueChange={this.updateState}
                                inline={true}
                                disabled={this.state.destDashMode.disabled}
                                hidden={this.state.destDashMode.disabled}
                              />
                            </Col>
                          </FormGroup>

                          <HorizontalFormInputs
                            ncols={["col-md-12"]}
                            label="Segment duration"
                            onValueChange={this.handleNumericFieldUpdate}
                            statekey="destHlsSegmentDuration"
                            value={this.state.container.destHlsSegmentDuration}
                            type="text"
                            bsClass="form-control"
                            placeholder="seconds"
                            disabled={this.state.destHlsMode.disabled}
                            hidden={this.state.destHlsMode.disabled}
                          />
                          {this.state.destHlsSegmentDurationError}
                          <HorizontalFormInputs
                            ncols={["col-md-12"]}
                            label="Fragment duration"
                            onValueChange={this.handleNumericFieldUpdate}
                            statekey="destHlsFragmentDuration"
                            value={this.state.container.destHlsFragmentDuration}
                            type="text"
                            bsClass="form-control"
                            placeholder="seconds"
                            disabled={this.state.destHlsMode.disabled}
                            hidden={this.state.destHlsMode.disabled}
                          />
                          {this.state.destHlsFragmentDurationError}
                          <HorizontalFormInputs
                            ncols={["col-md-12"]}
                            label="Time shift buffer depth"
                            onValueChange={this.handleNumericFieldUpdate}
                            statekey="destHlsTimeShiftBufferDepth"
                            value={this.state.container.destHlsTimeShiftBufferDepth}
                            type="text"
                            bsClass="form-control"
                            placeholder="seconds"
                            disabled={this.state.destHlsMode.disabled}
                            hidden={this.state.destHlsMode.disabled}
                          />
                          {this.state.destHlsTimeShiftBufferDepthError}
                          <HorizontalFormInputs
                            ncols={["col-md-12"]}
                            label="Preserved segments outside of live window"
                            onValueChange={this.handleNumericFieldUpdate}
                            statekey="destHlsPreservedSegmentsOutsideOfLiveWindow"
                            value={this.state.container.destHlsPreservedSegmentsOutsideOfLiveWindow}
                            type="text"
                            bsClass="form-control"
                            placeholder="number of segments"
                            disabled={this.state.destHlsMode.disabled}
                            hidden={this.state.destHlsMode.disabled}
                          />
                          {this.state.destHlsPreservedSegmentsOutsideOfLiveWindowError}
                          <FormGroup style={{ marginBottom: -10 + "px" }}>
                            <Col
                              componentClass={ControlLabel}
                              style={{ marginTop: 5 + "px" }}
                              md={5}
                            >
                              <Checkbox
                                number="cb4"
                                checked={this.state.container.destHlsEnableIframe}
                                label="I-Frames"
                                statekey="destHlsEnableIframe"
                                onValueChange={this.updateState}
                                inline={true}
                                disabled={this.state.destHlsMode.disabled}
                                hidden={this.state.destHlsMode.disabled}
                              />
                            </Col>
                          </FormGroup>

                          <div className="clearfix" />
                        </div>
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <Card
                      title="Graph Settings"
                      content={
                        <div className={"form form-horizontal"}>
                          <HorizontalFormInputs
                            ncols={["col-md-6"]}
                            label="Update Interval(seconds)"
                            onValueChange={this.handleInterval}
                            statekey="interval"
                            value={this.state.container.interval}
                            type="text"
                            bsClass="form-control"
                            placeholder="Interval"
                          />
                          <div className="clearfix" />
                          {this.state.intervalError}
                        </div>
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <Card
                      title="Stream metadata"
                      content={
                        <div className={"form form-horizontal"}>
                          <HorizontalFormInputs
                            ncols={["col-md-6"]}
                            label="Stream comment"
                            onValueChange={this.updateState}
                            statekey="comment"
                            value={this.state.container.comment}
                            type="text"
                            bsClass="form-control"
                            placeholder="Comment"
                          />

                          <div className="clearfix" />
                        </div>
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={2} mdOffset={5} style={{ display: "grid" }}>
                    <Button
                      bsStyle="info"
                      pullRight
                      fill
                      type="submit"
                      onClick={this.onSave}
                      disabled={!this.state.formValid}
                    >
                      Save
                    </Button>
                  </Col>
                </Row>
              </Panel.Body>
            </Panel>
          </Form>
        </Grid>
      </div>
    );
  }
}

StreamConfig.propTypes = {
  actions: PropTypes.object.isRequired
};

function getContainer(containers, containerId) {
  let container = containers.filter(container => container.Id === containerId);
  if (container.length > 0) return container[0];
  else return containers[0]; //TODO: might have to make a call to the api to retrieve the container
}

function getSelectedNic(nics, selectedIP) {
  let n = nics.filter(nic => {
    return nic[Object.keys(nic)[0]].address === selectedIP;
  })[0];
  if (n) return Object.keys(n)[0];
  else return null;
  //return Object.keys(nics[0])[0];
}

function getEncryption(selectedEncryption) {
  switch (selectedEncryption) {
    case '16':
      return "AES128";

    case '24':
      return "AES196";

    case '32':
      return "AES256";

    default:
      return "Disabled";
  }
}

function setDisabledSourceControls(container) {
  if (
    container.sourceProtocol &&
    container.sourceProtocol.toLowerCase() === "srt"
  )
    return { disabled: false };
}

function setDisabledDestControls(container) {
  if (container.destProtocol && container.destProtocol.toLowerCase() == "srt")
    return { disabled: false };
}

function setDisabledSourceOutgoingPort(container) {
  if (container.sourceSrtMode && container.sourceSrtMode.toLowerCase() == "caller")
    return { disabled: false };
  setDisabledSourceControls(container)
}

function setDisabledDestOutgoingPort(container) {
  if (container.destSrtMode && container.destSrtMode.toLowerCase() == "caller")
    return { disabled: false };
  setDisabledDestControls(container)
}

function setDisabledDestDashControls(container) {
  if (container.destProtocol && container.destProtocol.toLowerCase() == "dash")
    return { disabled: false };
}

function setDisabledDestHlsControls(container) {
  if (container.destProtocol && container.destProtocol.toLowerCase() == "hls")
    return { disabled: false };
}

function setDisabledDestQamControls(container) {
  if (container.destProtocol && container.destProtocol.toLowerCase() == "qam")
    return { disabled: false };
}

function getQamConfig(qamConfig) {
  if(additionalData && (!additionalData.schedule || additionalData.schedule.length < 1)) {
    additionalData['schedule'] = [{from: new moment(), to: new moment()}];
  }
  return additionalData;
}

/*function setDestDashDir(container) {
  if (container.destDashDir && container.destDashDir !== "") {
    return container.destDashDir;
  } else {
    return "";
  }
}*/

function mapStateToProps(state, ownProps) {
  let containerId = ownProps.match.params.id;
  let container = state.streamConfig.container;
  if (containerId) {
      container = getContainer(state.streamList.containers, containerId);
  }
  //container.destDashDir = setDestDashDir(container);
  return {
    container: Object.assign({
      destDashDir: "",
      qamConfig: {
        frequency: "",
        mode: "",
        interleaver: ""
      }
    }, container),
    error: state.error,
    validationError: state.streamConfig.validationError,
    nics: state.sysConfig.nics.eth,
    sourceAdapter: getSelectedNic(
      state.sysConfig.nics.eth,
      container.sourceAdapter
    ),
    destAdapter: getSelectedNic(
      state.sysConfig.nics.eth,
      container.destAdapter
    ),
    sourceSrtMode: setDisabledSourceControls(container),
    destSrtMode: setDisabledDestControls(container),
    sourceOutgoingPort: setDisabledSourceOutgoingPort(container),
    destOutgoingPort: setDisabledDestOutgoingPort(container),
    destDashMode: setDisabledDestDashControls(container),
    destHlsMode: setDisabledDestHlsControls(container),
    destQamMode: setDisabledDestQamControls(container),
    sourceEncryption: getEncryption(container.sourceEncryption),
    destEncryption: getEncryption(container.destEncryption),
    enableDASH: state.sysConfig.about.enableDASH,
    enableQam: state.sysConfig.about.enableQam
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StreamConfig);
